import { AI_QUOTA_USAGE_STATUS, useAIQuota } from 'core/hooks/useAIQuota';

type PracticeTutorQuota = {
  isQuotaExhausted: boolean;
};

/**
 * Whether the exercise can still hand the student over to the tutor. It never requests the quota:
 * the provider reads it on mount and the engine reports it after every turn, so a second read on
 * every exercise mount would only repeat the request.
 */
function usePracticeTutorQuota(): PracticeTutorQuota {
  const { usage } = useAIQuota();

  return { isQuotaExhausted: usage?.status === AI_QUOTA_USAGE_STATUS.EXHAUSTED };
}

export default usePracticeTutorQuota;
